<template>
  <div class="body-box">
    <!-- 搜索与添加区域 -->
    <el-row class="plan">
      <el-col :span="19">
        <el-button icon="el-icon-plus" @click="addDialogVisible = true">新增</el-button>
      </el-col>
      <el-col :span="5">
        <search-input v-model="queryInfo.keyword" placeholder="请输入关键字进行搜索" @change="handleQuery" />
      </el-col>
    </el-row>


    <el-table :height="'calc(100% - 70px)'" :data="dictList" row-key="id" class="button-box" :tree-props="{ children: 'children' }">
      <el-table-column label="分类名称" prop="name"></el-table-column>
      <el-table-column label="创建时间" prop="createDatetime">
        <template slot-scope="scope">
          {{ scope.row.createDatetime | formatDate('yyyy-MM-dd hh:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column label="分类说明" prop="describe"></el-table-column>
      <el-table-column label="操作" min-width="180px">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" @click="editDict(scope.row)">修改</el-button>
          <el-button icon="el-icon-delete" @click="removeDictById(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加分类对话框 -->
    <el-dialog
        title="添加分类"
        :visible.sync="addDialogVisible"
        width="40%"
        append-to-body
        @close="addDialogClosed"
    >
      <el-form
          ref="addFormRef"
          :model="addForm"
          :rules="rules"
          label-width="120px"
      >
        <el-row>
          <el-col :span="24">
            <el-alert title="创建一级分类不需要选择上级分类" type="warning" style="margin-bottom: 20px"></el-alert>
            <el-form-item label="选择上级分类" prop="name">
              <el-select style="width: 100%;" v-model="addForm.pid" placeholder="请选择">
                <el-option
                    v-for="item in dictList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="分类名称" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入分类名称"/>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="说明" prop="describe">
              <el-input
                  type="textarea"
                  v-model="addForm.describe"
                  placeholder="请输入说明"
                  maxlength="32"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button @click="addDict">确 定</el-button>
      </div>
    </el-dialog>


    <!-- 修改分类对话框 -->
    <el-dialog
        title="修改分类"
        :visible.sync="editOpen"
        width="40%"
    >
      <el-form ref="addFormRef" :rules="rules" :model="editForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="选择上级分类" prop="name">
              <el-select style="width: 100%;" v-model="editForm.pid" placeholder="请选择">
                <el-option
                    v-for="item in dictList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="分类名称" prop="name">
              <el-input v-model="editForm.name" placeholder="请输入分类名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="说明" prop="describe">
              <el-input
                  type="textarea"
                  v-model="editForm.describe"
                  placeholder="请输入说明"
                  maxlength="32"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editOpen = false">取 消</el-button>
        <el-button type="primary" @click="modifyDict">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {getData, getPostOrDeleteData} from '@/utils/code'
import {addDict, deleteDict, getDictTreeList, selectDictByKey, updateDict} from '@/api/user/dict/dict'
import {deleteTips, title} from '@/utils/tips'
import SearchInput from '@/components/common/searchInput/searchInput'

export default {
  components: { SearchInput },
  data() {
    return {
      // 查询参数
      queryInfo: {
        keyword: '',
        key: 'CLASSIFY'
      },
      // 分类列表
      dictList: [],
      addDialogVisible: false,
      editOpen: false,
      addForm: {}, //添加组织表单
      editForm: {}, //修改
      // 规则
      rules: {
        name: [
          {required: true, message: '分类名称不能为空', trigger: 'blur'}
        ],
      }
    }
  },
  created() {
    this.getDictList()
  },
  methods: {
    // 所有列表
    async getDictList() {
      getDictTreeList(this.queryInfo).then((response) => {
        let data = getData(response)
        this.dictList = data ? data : []
      })
    },

    // 监听添加用户对话框的关闭事件 /  重置表单
    addDialogClosed() {
      this.addForm = {}
    },
    // 添加
    addDict() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        this.addForm.value = this.addForm.name;
        this.addForm.keyword = 'CLASSIFY';
        addDict(this.addForm).then((response) => {
          let data = getData(response)
          if (data !== null) {
            this.getDictList()
            this.addDialogVisible = false
          }
        })
      })
    },

    // 删除
    async removeDictById(id) {
      let b = await deleteTips(title.deleteTitle)
      if (b) {
        deleteDict(id).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.getDictList()
          }
        })
      }
    },

    // 修改
    editDict(row) {
      this.editForm = JSON.parse(JSON.stringify(row))
      this.editOpen = true
    },

    modifyDict() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        this.editForm.value = this.editForm.name;
        this.editForm.keyword = 'CLASSIFY';
        updateDict(this.editForm.id, this.editForm).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.getDictList()
            this.editOpen = false
          }
        })
      })
    },

    // 查询
    getHande() {
      selectDictByKey(this.queryInfo.key).then((response) => {
        this.dictList = getData(response) ? getData(response) : []
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      if (this.queryInfo.key === '') {
        this.getDictList()
      } else {
        this.getHande()
      }
    }

  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  padding-right: 30px;

  .el-input__inner {
    height: 36px;
    line-height: 36px;
  }
}
</style>
